export class TriggerEvent<T = any> extends CustomEvent<T> {
  constructor(detail?: T) {
    super('trigger', { detail });
  }
}
